/** Human-readable name for a pinned model id.
 *
 * The candidate is told which model they are talking to, because "the AI" is
 * not a comparable thing between two candidates a month apart and the model id
 * is not something to put in front of them.
 */
const FAMILIES = ["opus", "sonnet", "haiku", "fable"];

export function modelDisplayName(id: string | null | undefined): string {
  const raw = (id ?? "").trim();
  if (!raw.startsWith("claude-")) return raw || "the assistant";

  // A trailing snapshot date is a release detail, not part of the name.
  const parts = raw.slice("claude-".length).split("-").filter(Boolean);
  const dated = parts.length > 1 && /^\d{8}$/.test(parts[parts.length - 1]);
  const named = dated ? parts.slice(0, -1) : parts;

  const at = named.findIndex((p) => FAMILIES.includes(p.toLowerCase()));
  if (at === -1) return raw;

  const family = named[at][0].toUpperCase() + named[at].slice(1).toLowerCase();
  const version = named.slice(at + 1).filter((p) => /^\d+$/.test(p));
  return version.length ? `${family} ${version.join(".")}` : family;
}
